export default __webpack_public_path__ + "static/media/Power_Supply_Leads.a0542b6f.svg";